import { Navigate, Route } from 'react-router-dom';

import { lazy } from 'react';
import useChangePage, { adminPortalUrl } from '../hooks/useChangePage/useChangePage';
import { adminPortalRoles } from '../lib/constants/roles';

const ProtectedLayout = lazy(() => import('../features/layout/ProtectedLayout/ProtectedLayout'));
const BatchSendAppDownloadPageComponent = lazy(() => import('../features/adminPortal2/utilities/component/BatchSendAppDownloadPageComponent/BatchSendAppDownloadPageComponent'));
const BatchSendConsentPageComponent = lazy(() => import('../features/adminPortal2/utilities/component/BatchSendConsentPageComponent/BatchSendConsentPageComponent'));
const MobileVersionConfigDashboardComponent = lazy(() => import('../features/mobileVersionConfiguration/component/MobileVersionConfigDashboardComponent/MobileVersionConfigDashboardComponent'));
const MedicalOrgDashboardComponent = lazy(() => import('../features/adminPortal2/medicalOrg/component/MedicalOrgDashboardComponent/MedicalOrgDashboardComponent'));
const UserDirectoryPageComponent = lazy(() => import('../features/adminPortal2/users/component/UserDirectoryPageComponent/UserDirectoryPageComponent'));
const UserProfileComponent = lazy(() => import('../features/user/component/UserProfileComponent/UserProfileComponent'));
const AdminPortalLayoutComponent = lazy(() => import('../features/adminPortal2/layout/AdminPortalLayoutComponent/AdminPortalLayoutComponent'));
const MedicalOrgPageComponent = lazy(() => import('../features/adminPortal2/medicalOrg/component/MedicalOrgPageComponent/MedicalOrgPageComponent'));
const UsersBasePageComponent = lazy(() => import('../features/adminPortal2/users/component/UsersBasePageComponent/UsersBasePageComponent'));
const AdminPortalHomePageComponent = lazy(() => import('../features/adminPortal2/home/component/AdminPortalHomePageComponent/AdminPortalHomePageComponent'));
const CareOperationHierarchyPageComponent = lazy(() => import('../features/adminPortal2/careOperationHierarchy/component/CareOperationHierarchyPageComponent/CareOperationHierarchyPageComponent'));
const AdminPortalUtilitiesPageComponent = lazy(() => import('../features/adminPortal2/utilities/component/AdminPortalUtilitiesPageComponent/AdminPortalUtilitiesPageComponent'));
const AnnouncementDashboardComponent = lazy(() => import('../features/announcement/component/AnnouncementDashboardComponent/AnnouncementDashboardComponent'));

export const createAdminPortalRoutes = () => {
  const page = useChangePage();
  return (
    <Route path={adminPortalUrl}>
      <Route
        element={(
          <ProtectedLayout roleWhiteList={adminPortalRoles} />
        )}
      >
        <Route element={<AdminPortalLayoutComponent />}>
          <Route
            index
            element={<Navigate to={page.createAdminPortalHomeUrl()} />}
          />
          <Route
            path={page.createAdminPortalHomeUrl()}
            element={<AdminPortalHomePageComponent />}
          />
          <Route
            path={page.createAdminPortalCareOperationHierarchyUrl()}
            element={<CareOperationHierarchyPageComponent />}
          />
          <Route
            path={page.createAdminPortalMedicalOrganizationsUrl()}
            element={<MedicalOrgDashboardComponent />}
          />
          <Route
            path="/admin-portal/medical-orgs/:medicalOrgId"
            element={<MedicalOrgPageComponent />}
          />
          <Route
            path={page.createAdminPortalUsersUrl()}
            element={<UserDirectoryPageComponent />}
          />
          <Route
            path="/admin-portal/users/:id"
            element={<UsersBasePageComponent />}
          />
          <Route
            path={page.createAdminPortalUtilitiesUrl()}
            element={<AdminPortalUtilitiesPageComponent />}
          />
          <Route
            path={page.createAdminPortalSettingsUrl()}
            element={<UserProfileComponent />}
          />
          <Route
            path="/admin-portal/utilities/mobile-versions-config"
            element={<MobileVersionConfigDashboardComponent />}
          />
          <Route
            path="/admin-portal/utilities/batch-send-consent"
            element={<BatchSendConsentPageComponent />}
          />
          <Route
            path="/admin-portal/utilities/batch-send-app-download"
            element={<BatchSendAppDownloadPageComponent />}
          />
          <Route
            path="/admin-portal/utilities/announcement"
            element={<AnnouncementDashboardComponent />}
          />
        </Route>
      </Route>
    </Route>
  );
};

export default createAdminPortalRoutes;
